export default __webpack_public_path__ + "static/media/product-page-5.5f13044c.png";